import { create } from 'zustand'
import type { CreateCustomerData } from './schemas'

type CreateCustomerStoreState = {
  data: Partial<CreateCustomerData>
  updateData: (patch: Partial<CreateCustomerData>) => void
  reset: () => void
}

export const useCreateCustomerStore = create<CreateCustomerStoreState>((set) => ({
  data: {},
  updateData: (patch) => {
    set((state) => ({
      data: {
        ...state.data,
        ...patch,
      },
    }))
  },
  reset: () => {
    set({ data: {} })
  },
}))

export default useCreateCustomerStore
